// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"winter-sale_saveTag__SiUfT","text":"winter-sale_text__pjuUI"};